let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1VXoM")).then(() => parcelRequire('8YYHz'));